import clsx from 'clsx';
import React from 'react';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { GetClasses } from '@lifeomic/chroma-react/typeUtils';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  content: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

export type FilterContainerClasses = GetClasses<typeof useStyles>;

export interface FilterContainerProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  header?: React.ReactNode;
  headerClassName?: string;
  contentClassName?: string;
  footer?: React.ReactNode;
}

export const FilterContainer: React.FC<FilterContainerProps> = props => {
  const {
    children,
    className,
    footer,
    header,
    headerClassName,
    contentClassName,
    ...rootProps
  } = props;

  const classes = useStyles(props);

  return (
    <div className={clsx(classes.root, className)} {...rootProps}>
      {!!header && (
        <div className={clsx(classes.header, headerClassName)}>{header}</div>
      )}
      <div className={clsx(classes.content, contentClassName)}>{children}</div>
      {!!footer && <div className={classes.footer}>{footer}</div>}
    </div>
  );
};

export default FilterContainer;
